/**
 * Insights — type definitions for weekly industry analysis articles.
 *
 * Articles live as MDX files in `content/insights/` with YAML frontmatter:
 *
 *   ---
 *   title: "Week 23 — Submarine cables and 800G DWDM advances"
 *   slug: 2026-w23-dwdm-roundup
 *   date: 2026-06-04
 *   tags: [dwdm, submarine-cables, m-and-a]
 *   author: yuliy-nushev
 *   excerpt: "..."
 *   coverImage: /insights/2026-w23-cover.webp     (optional)
 *   language: en                                   (en | bg, default en)
 *   draft: false                                   (optional, hides from production)
 *   ---
 */

export type InsightTag =
  | "dwdm"
  | "submarine-cables"
  | "ip-transit"
  | "routing"
  | "regulation"
  | "m-and-a"
  | "bulgaria"
  | "caucasus"
  | "eu-funding"
  | "peering"
  | "security";

export type InsightLanguage = "en" | "bg";

export type InsightAuthorId = "yuliy-nushev" | "sofia-connect-team";

export interface InsightAuthor {
  id: InsightAuthorId;
  name: string;
  title: string;
  url?: string;
}

export interface InsightFrontmatter {
  title: string;
  slug: string;
  date: string; // ISO YYYY-MM-DD
  tags: InsightTag[];
  author: InsightAuthorId;
  excerpt: string;
  coverImage?: string;
  language?: InsightLanguage;
  draft?: boolean;
}

export interface InsightArticle {
  frontmatter: InsightFrontmatter;
  /** Raw MDX body (frontmatter stripped). */
  content: string;
  /** Estimated read time, e.g. "5 min read". */
  readingTime: string;
  /** Word count. */
  words: number;
}

export const TAG_LABELS: Record<InsightTag, string> = {
  dwdm: "DWDM",
  "submarine-cables": "Submarine Cables",
  "ip-transit": "IP Transit",
  routing: "Routing & BGP",
  regulation: "Regulation",
  "m-and-a": "M&A",
  bulgaria: "Bulgaria",
  caucasus: "Caucasus",
  "eu-funding": "EU Funding",
  peering: "Peering",
  security: "Security",
};

export const AUTHORS: Record<InsightAuthorId, InsightAuthor> = {
  "yuliy-nushev": {
    id: "yuliy-nushev",
    name: "Yuliy Nushev",
    title: "CEO, Sofia Connect EAD · Honorary Consul of Georgia in Bulgaria",
    url: "/about/",
  },
  "sofia-connect-team": {
    id: "sofia-connect-team",
    name: "Sofia Connect Team",
    title: "Editorial Team",
  },
};
